module.exports = __webpack_public_path__ + "static/media/Window-to-Bharat.838f0a2f.png";